module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAASCAYAAAAzI3woAAAA4UlEQVRIiWP8DwQMgwgwEaPo+MmzDNZOAWCa1oCRUAiBHFFY1sjw/sNHBkEBfob+rnoGS3NjsJytSzDDq9dvsOoTExVhOLxnLeku+k8AuPlG/z9x6tx/NT27/ydPn//v6hP5/9+/f4S0kQ0IOggGQA6iByAqDdETsFCimRZpiCIHkWNhcf10DLHexkw4m+5Rhmw5Nv6AJeqiumlYxQmWQzCgrm/PcPPiQRSxYZGGCIFBl+0JOsjNN4rh1JkLYDawxGZw94uhqYOGXl0GAsdOnPlv6eAPpmkNiM5l9AKDLlEDAOImg8rxR3jJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhjtb1-1.png
// module id = 861
// module chunks = 0